var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21094 13C10.3164 13 11.6221 11.9131 11.6221 10.1768C11.6221 8.87109 10.6377 7.89355 9.29785 7.79102V7.73633C10.3438 7.5791 11.1504 6.67676 11.1504 5.59668C11.1504 4.08594 9.98828 3.13574 8.13574 3.13574H3.84277V13H8.21094ZM5.90723 4.67383H7.60254C8.56641 4.67383 9.12012 5.125 9.12012 5.91797C9.12012 6.75195 8.49121 7.2373 7.39062 7.2373H5.90723V4.67383ZM5.90723 11.4619V8.59766H7.63672C8.85352 8.59766 9.5166 9.08984 9.5166 10.0127C9.5166 10.9561 8.87402 11.4619 7.68457 11.4619H5.90723Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldButton);
export default __webpack_public_path__ + "static/media/boldButton.39835ee7f5b3c4faad69bd9169b52819.svg";
export { ForwardRef as ReactComponent };